import { LogoutIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';

import Layout from '@/layouts/index.vue';

export default [
  {
    path: '/loginRedirect',
    name: 'loginRedirect',
    redirect: '/login',
    meta: { title: { zh_CN: '登录页', en_US: 'Login' }, icon: shallowRef(LogoutIcon), hidden: true },
    component: () => import('@/layouts/blank.vue'),
    children: [
      {
        path: 'index',
        redirect: '/login',
        component: () => import('@/layouts/blank.vue'),
        meta: { title: { zh_CN: '登录页', en_US: 'Login' } },
      },
    ],
  },
  {
    path: '/user',
    name: 'user',
    component: Layout,
    meta: {
      title: { zh_CN: '个人中心', en_US: 'Profile' },
      hidden: true,
    },
    children: [
      {
        path: 'index',
        name: 'UserProfile',
        component: () => import('@/pages/user/index.vue'),
        meta: {
          title: { zh_CN: '个人中心', en_US: 'Profile' },
          hidden: true,
          hiddenBreadcrumb: true,
        },
      },
    ],
  },
];
